import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";

function DocumentLanguageAndMeta() {
  const { i18n: i18nInstance } = useTranslation();
  useEffect(() => {
    document.documentElement.lang =
      i18nInstance.language === "en" ? "en" : "zh-CN";
    document.title = i18nInstance.t("meta.title");
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", i18nInstance.t("meta.description"));
    }
    const keywords = document.querySelector('meta[name="keywords"]');
    if (keywords) {
      keywords.setAttribute("content", i18nInstance.t("meta.keywords"));
    }
  }, [i18nInstance, i18nInstance.language]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <DocumentLanguageAndMeta />
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
